export enum AppType {
  Quicklister = 'quicklister',
  CompanyManagement = 'companyManagement',
  PhotoService = 'photoService',
  QuickFinder = 'quickFinder',
  UserManagement = 'userManagement',
  HomesUsaAdmin = 'homesUsaAdmin',
  LeadManagement = 'leadManagement'
}

export const getAppTypeLabel = (app: AppType): string => {
  switch (app) {
    case AppType.Quicklister:
      return 'Quicklister';
    case AppType.CompanyManagement:
      return 'Company Management';
    case AppType.PhotoService:
      return 'Photo Service';
    case AppType.QuickFinder:
      return 'QuickFinder';
    case AppType.UserManagement:
      return 'User Management';
    case AppType.HomesUsaAdmin:
      return 'HomesUSA.com';
    case AppType.LeadManagement:
      return 'Lead Management';
  }
};

export const appTypeUrl: Record<AppType, string> = {
  [AppType.Quicklister]: process.env.REACT_APP_QuicklisterURI ?? 'https://specdeck.homesusa.com',
  [AppType.HomesUsaAdmin]: process.env.REACT_APP_HomesUsaAdminURI ?? 'https://admin.homesusa.com',
  [AppType.CompanyManagement]:
    process.env.REACT_APP_CompanyManagementURI ?? 'https://csm.homesusa.com',
  [AppType.PhotoService]: process.env.REACT_APP_PhotoServiceURI ?? 'https://ps.homesusa.com',
  [AppType.QuickFinder]:
    process.env.REACT_APP_QuickFinderURI ?? 'https://quickfinder.homesusa.com/',
  [AppType.UserManagement]: process.env.REACT_APP_UserManagementURI ?? 'https://login.homesusa.com',
  [AppType.LeadManagement]: process.env.REACT_APP_LeadManagementURI ?? 'https://leads.homesusa.com'
};
